/**
 * Physics clock
 *
 * This class is for getting delta time for wasm integrated physics
 */
export class PhysicsClock {
    _engine;
    constructor(engine) {
        this._engine = engine;
    }
    getDeltaTime() {
        const deltaTime = this._engine.getDeltaTime();
        if (deltaTime === 0) {
            return 1 / 60;
        }
        return deltaTime / 1000;
    }
}
